module.exports = __webpack_public_path__ + "static/media/thenightly_app_download_image_1.8b32c7d3.png";